import React, { Component } from 'react';
import * as d3 from 'd3';
import withTitle from '../components/withTitle';
import chart from './d3/d3-waterfallchart';

class WaterfallChart extends Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.chart = chart()
      .width(this.props.width)
      .height(this.props.height);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  componentDidUpdate() {
    this.chart
      .width(this.props.width)
      .height(this.props.height);

    const chartContainer = d3.select(this.refs.chart);
    chartContainer.datum(this.props.data).call(this.chart, this.props.isResize);
  }

  render() {
    return <div ref="chart" style={{ width: '100%' }} />
  }
}

export default withTitle(WaterfallChart);


// WEBPACK FOOTER //
// ./src/charts/WaterfallChart.js